import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.service-points')
  .factory('$servicePoints', servicePointsObjectFactory);

/* @ngInject */
function servicePointsObjectFactory($bringozFactory: $bringozFactory,
                                servicePointsAPI: BringozApi,
                                ServicePoints_DS: DataStoreConfig,
                                ServicePoints_PN: PushNotificationsConfig) {

  function $servicePoints(id?: string) {
    return $bringozFactory(id, servicePointsAPI, ServicePoints_DS, ServicePoints_PN);
  }

  return $servicePoints;
}
